import { useMemo, useState } from "react";
import { FieldValues, UseFormReturn } from "react-hook-form";
import styled from "styled-components";
import { z } from "zod";
import { Button } from "../../atoms/Button";
import { Input } from "../../atoms/Input";
import FormTemplate from "../../templates/FormTemplate";

type Props = {
  handleSubmit: (email: string, password: string) => void;
};

export const LoginForm: React.FC<Props> = ({ handleSubmit }) => {
  const schema = useMemo(() => {
    return z.object({
      email: z.string().min(1),
      password: z.string().min(1),
    });
  }, []);

  const [methods, setMethods] = useState<UseFormReturn<
    FieldValues,
    any,
    undefined
  > | null>(null);

  return (
    <FormTemplate
      schema={schema}
      setMethods={setMethods}
      defaultValues={{
        email: "",
        password: "",
      }}
      onSubmit={({ email, password }) => handleSubmit(email, password)}
    >
      <Wrapper>
        <InputContainer>
          <Input
            name="email"
            type="email"
            label="メールアドレス"
            dataWovnIgnore={true}
          />
        </InputContainer>
        <InputContainer>
          <Input
            name="password"
            type="password"
            label="パスワード"
            dataWovnIgnore={true}
          />
        </InputContainer>
      </Wrapper>

      <ButtonWrapper>
        <Button type="submit" text="ログイン" btnStyle="primary" rounded="md" />
      </ButtonWrapper>
    </FormTemplate>
  );
};

const InputContainer = styled.div`
  margin-bottom: 20px;
`;

const Wrapper = styled.div`
  overflow: hidden;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 16px;
  margin-bottom: 12px;
  button {
    font-family: "Hiragino Sans";
    font-weight: 600;
    line-height: 1em;
    height: auto;
  }
`;
